export function hasUserConsentLib() {
    return !!window.WM;
}

export function inUserConsentState(consentCategories) {
    return (window.WM) ? window.WM.UserConsent.inUserConsentState(consentCategories) : false;
}

export function isGDPR() {
    return (window.WM.UserConsent.getRegion() === 'gdpr');
}

export function isCCPA() {
    return (window.WM.UserConsent.getRegion() === 'ccpa');
}

export function getUspAPIstring() {
    return (window.WM) ? WM.UserConsent.getUspAPIstring() : '';
}

export function getTcfAPIstring() {
    return (window.WM) ? WM.UserConsent.getTcfAPIstring() : '';
}



// WEBPACK FOOTER //
// ./src/utils/UserConsent.js